import { AbstractControl } from '@angular/forms'

const passwordNumericRE = /\d+/
const passwordUppercaseLetterRE = /[A-Z]+/

export const PasswordValidator = (control: AbstractControl) => {
  const value = control.value ?? ''
  if (value && !value.match(passwordNumericRE)) {
    return { 'password-must-contain-numeric': true }
  }
  if (value && !value.match(passwordUppercaseLetterRE)) {
    return { 'password-must-contain-uppercase': true }
  }
  return null
}
